import './style.scss'

import { axios as $http } from 'cm'
import { getEnvHost } from 'src/frontend-lib/tools/getPlatform'
import Bridge from 'src/frontend-lib/lib/Bridge'
let myBridge = new Bridge()
let IS_APP = window.$platform.isYixinliApp
let envHost = window.location.protocol + getEnvHost(`//m.xinli001.com`)
$(document).delegate('.similarProblem .item', 'click', function() {
  let href = envHost + '/qa/' + $(this).attr('data-id')
  if (IS_APP) {
    myBridge.call('openWebView', {
      url: href,
      isCurrentPageOpen: 0
    })
  } else {
    window.location.href = href
  }
})

export default class similarProblem {
  constructor(id) {
    this.id = id
    // <ul class="authors">
    //   <li>
    //     <img src="../../../page-resource/ask/index/icon-askindex-reward@2x.png" alt="">
    //   </li>
    //   <li>
    //     <img src="../../../page-resource/ask/index/icon-askindex-reward@2x.png" alt="">
    //   </li>
    //   <li>
    //     <img src="../../../page-resource/ask/index/icon-askindex-reward@2x.png" alt="">
    //   </li>
    //   <li>
    //     <img src="../../../page-resource/ask/index/icon-askindex-reward@2x.png" alt="">
    //   </li>
    // </ul>
  }

  render() {
    return new Promise((resolve, reject) => {
      $http
        .get(`${envHost}/ajax/get-recquestion-${this.id}.json`)
        .then(res => {
          let _res = res.data,
            _data = _res.data
          if (_res.code === 0) {
            if (_data.items.length > 0) {
              let list = ''
              _data.items.forEach(item => {
                list += `<li class="item" data-id="${item.id}">${item.title}(回答 ${item.commentnum})</li>`
              })
              resolve(`
                <div class="similarProblem">
                  <div class="wrap">
                    <p>其他相似问题</p>
                  </div>
                  <ul class="list">${list}</ul>
                </div>
              `)
            } else {
              resolve('<div class="similarProblem" style="padding: 0"></div>')
            }
          } else {
            resolve('<div class="similarProblem" style="padding: 0"></div>')
          }
        })
        .catch(() => {
          resolve('<div class="similarProblem" style="padding: 0"></div>')
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/components/similarProblem/index.js